import { Decimal } from '../../datastructures';
import { getConfigManager } from '../../config/getConfigManager';
import poolsPairBalanceAtom from './poolsPairBalance';
import poolTokenRatesAtom from './poolTokenRatesAtom';
import { createAsyncAtom } from '../../lib/state';

const poolsUserBalanceAtom = createAsyncAtom(async get => {
  const poolTokenRates = await get(poolTokenRatesAtom);
  const poolsPairBalance = await get(poolsPairBalanceAtom);

  const pools = getConfigManager().getConfig().pools;

  const poolsUserBalanceMap: { [pairId: string]: Decimal } = {};
  Object.entries(pools).map(([, pool]) => {
    const tokenARate = poolTokenRates[pool.pair.tokenA.address];
    const tokenBRate = poolTokenRates[pool.pair.tokenB.address];

    const tokenABalance = poolsPairBalance[pool.pair.id].tokenA;
    const tokenBBalance = poolsPairBalance[pool.pair.id].tokenB;

    if (tokenARate && tokenBRate && tokenABalance && tokenBBalance) {
      const tokenAValue = tokenARate.mul(tokenABalance);
      const tokenBValue = tokenBRate.mul(tokenBBalance);

      poolsUserBalanceMap[pool.pair.id] = tokenAValue.add(tokenBValue);
    } else {
      poolsUserBalanceMap[pool.pair.id] = Decimal.ZERO;
    }
  });

  return poolsUserBalanceMap;
});
export default poolsUserBalanceAtom;
